module.exports = __webpack_public_path__ + "media/images/icons/email-red-2f7687837192065a70d3b6efe8302e5b.png";